import { Drawer } from 'antd';
import AddSupplierForm from '../forms/add-supplier-form';
import { ISupplier } from "@drone-parts.garphild.pro/interfaces";
import { observer } from "mobx-react-lite";
import suppliersStorage from "../storages/suppliersStorage";

/* eslint-disable-next-line */
export interface AddSupplierDialogProps {
  opened: boolean;
  onToggle: () => void;
}

export function AddSupplierDialog(props: AddSupplierDialogProps) {
  const {
    opened,
    onToggle,
  } = props;

  const onSubmit = async (supplier: ISupplier) => {
    await suppliersStorage.createSupplier(supplier);
    onToggle();
  }

  return (
    <Drawer
      title="Add brand"
      width={320}
      closable={true}
      onClose={onToggle}
      open={opened}
    >
      <AddSupplierForm
        onSubmit={onSubmit}
      />
    </Drawer>
  );
}

export default observer(AddSupplierDialog);
